import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { yaCounter } from '@shared/pipes/ya-counter'
import styled, { CSSObject } from 'styled-components'

const logInvestApp = (): void => yaCounter.utils.reachGoal('invest_app')

export function SectionApps(): JSX.Element {
	return (
		<Section>
			<ViewRoot>
				<ImageBack name='investAppBack.png' alt='' />
				<ImagePhone name='investAppsPhone.png' alt='' />
				<ViewContent>
					<TextTitle>Удобное приложение</TextTitle>
					<List>
						<ListItem>
							<ListItemIcon />
							Безопасный и удобный вход по СМС — не нужно запоминать пароль
						</ListItem>
						<ListItem>
							<ListItemIcon />
							Подписание документов электронной подписью онлайн
						</ListItem>
						<ListItem>
							<ListItemIcon />
							История выплат и начисления доступны в любой момент
						</ListItem>
					</List>
					<a
						href='http://apps.apple.com/ru/app/credit-club-%D0%B4%D0%B5%D0%BD%D1%8C%D0%B3%D0%B8/id1594827999'
						aria-label="Скачать приложение Credit Club в App Store"
						target='_blank'
						rel='noopener noreferrer nofollow'
						onClick={logInvestApp}
					>
						<span className='visually-hidden'>Скачать приложение Credit Club в App Store</span>
						<ImageAppl name='investAppStore.png' alt='App Store' />
					</a>
					<a
						href='http://play.google.com/store/apps/details?id=soft.eac.creditclubclient'
						aria-label="Скачать приложение Credit Club в Play Store"
						target='_blank'
						rel='noopener noreferrer nofollow'
						onClick={logInvestApp}
					>
						<span className='visually-hidden'>Скачать приложение Credit Club в Play Store</span>
						<ImageGgl name='InvestPlayStore.png' alt='Play Store' />
					</a>
				</ViewContent>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(
	({ theme }) =>
		({
			backgroundColor: theme.colors.lightmint,
			borderRadius: 40,
			marginBottom: 60,
			position: 'relative',
			paddingTop: 20,
			paddingLeft: 20,
			paddingRight: 20,
			[theme.mediaQueries.mediaMinWidthMobile]: {
				marginBottom: 100,
				paddingTop: 40,
				paddingLeft: 60,
				paddingRight: 60,
			},
		} as CSSObject)
)

const ViewContent = styled.div(
	({ theme }) =>
		({
			marginRight: 'auto',
			width: '100%',
			position: 'inherit',
			paddingBottom: 30,
			[theme.mediaQueries.mediaMinWidthMobile]: {
				width: '40%',
				paddingBottom: 40,
			},
		} as CSSObject)
)

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
	},
}))

const ImageBack = styled(Image)(({ theme }) => ({
	position: 'absolute',
	height: '100%',
	right: 0,
	bottom: 0,
	width: '50%',
	display: 'none',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		display: 'block',
	},
}))

const ImagePhone = styled(Image)(({ theme }) => ({
	position: 'absolute',
	right: '5%',
	bottom: 0,
	maxHeight: '110%',
	maxWidth: '40%',
	display: 'none',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		display: 'block',
	},
}))

const List = styled.ul(({ theme }) => ({
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 30,
	},
}))

const ListItem = styled.li(({ theme }) => ({
	paddingLeft: 16,
	position: 'relative',
	marginBottom: 20,
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 10,
		...theme.typography.text18_24,
	},
}))

const ListItemIcon = styled.span(
	({ theme }) =>
		({
			position: 'absolute',
			width: 10,
			height: 10,
			left: 0,
			top: 6,
			backgroundColor: theme.colors.main,
			borderRadius: '50%',
		} as CSSObject)
)

const ImageAppl = styled(Image)(({ theme }) => ({
	width: 113,
	height: 38,
	marginRight: 10,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: 20,
	},
}))
const ImageGgl = styled(Image)(() => ({
	width: 134,
	height: 38,
}))
